import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';

const initialState = {
  audios: {}, 
  loading: false,
  error: null,
  pagination: {},
  selectedAudio:null
};

/* ================== THUNKS ================== */

export const fetchAudioLibraries = createAsyncThunk(
  'audio-libraries/fetch',
  async ({ fetchType = "table", page = 1, limit = 10, search = '' }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get('/api/admin/audio-libraries', {
            params: { fetchType, page, limit, search }
        });
        
        return {
            data: response.data?.data?.records || [],
            pagination: response.data?.data?.pagination || {},
        };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const createAudioLibrary = createAsyncThunk(
  'audio-libraries/create',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        '/api/admin/audio-libraries/store', 
        payload
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const fetchAudioLibraryById = createAsyncThunk(
  'audio-libraries/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/admin/audio-libraries/${id}`);
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const updateAudioLibrary = createAsyncThunk(
  'audio-libraries/update',
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`/api/admin/audio-libraries/${id}`, formData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const deleteAudioLibrary = createAsyncThunk(
  'audio-libraries/delete',
  async ({ id, type }, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/api/admin/audio-libraries/${id}`);
      return { id, type };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

/* ================== SLICE ================== */

const audioLibrariesSlice = createSlice({
  name: 'audios',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      /* FETCH */
      .addCase(fetchAudioLibraries.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAudioLibraries.fulfilled, (state, action) => {
        const { data, pagination } = action.payload;
        state.loading = false;
        state.audios = data;
        state.pagination = pagination;
      })
      .addCase(fetchAudioLibraries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* CREATE */
      .addCase(createAudioLibrary.fulfilled, (state, action) => {
        
      })

      .addCase(fetchAudioLibraryById.fulfilled, (state, action) => {
          state.loading = false;
          state.selectedAudio = action.payload;
      })
      .addCase(fetchAudioLibraryById.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
      })

      /* UPDATE */
      .addCase(updateAudioLibrary.fulfilled, (state, action) => {        
        console.log(state,'state');
      })

      /* DELETE */
      .addCase(deleteAudioLibrary.fulfilled, (state, action) => {
        state.audios = state.audios.filter((p) => p._id !== action.payload);
      });
  }
});

export default audioLibrariesSlice.reducer;